export default {"src":"/v1/_next/static/media/helpful.bbc00723.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};